export default "__VITE_PUBLIC_ASSET__ea043826__"